import Add from '@mui/icons-material/Add';
import { TextField, InputAdornment, IconButton, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useRef, useState } from 'react';

interface NoteCreatorProps {
  handleNewNote: (newNotes: string) => void;
}

const NoteCreator: React.FC<NoteCreatorProps> = ({ handleNewNote }) => {
  const [newNoteText, setNewNoteText] = useState('');
  const newNoteInputRef = useRef<HTMLInputElement>(null);

  const addNote = () => {
    if (newNoteText.trim()) {
      handleNewNote(newNoteText.trim());
      newNoteInputRef.current?.focus();
      setNewNoteText('');
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey && newNoteText.trim() !== '') {
      e.preventDefault();
      addNote();
    }
  };

  return (
    <React.Fragment>
      <Box sx={{ mb: 2, mt: 1 }}>
        <TextField
          inputRef={newNoteInputRef}
          value={newNoteText}
          onChange={(e) => setNewNoteText(e.target.value)}
          onKeyDown={handleKeyPress}
          placeholder="Add a new meeting point..."
          fullWidth
          multiline
          variant="outlined"
          size="small"
          InputProps={{
            endAdornment: newNoteText && (
              <InputAdornment position="end">
                <IconButton onClick={addNote} size="small" edge="end">
                  <Add />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Typography variant="body2" color="text.secondary">
        {' '}
        Press Enter to add a point and Press Shift+Enter for new line{' '}
      </Typography>
    </React.Fragment>
  );
};

export default NoteCreator;
